import React from 'react';
import { Box, Button, CircularProgress, IconButton, InputAdornment, OutlinedInput, Typography } from '@mui/material';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { blue, grey } from 'app/components/ThemeProvider/colors';
import { inputInfo, forgetPassBox, forgetPassText, warningBox, errorText, btn } from './LoginForm.sx';
import useLoginForm from './useLoginForm';
import WarningIcon from 'app/components/Icons/WarningIcon';

interface Props {
  tabNumber: number;
}
const LoginForm = (props: Props) => {
  const { tabNumber } = props;
  const {
    t,
    showPassword,
    firstInput,
    secondInput,
    errors,
    register,
    isLoadingLogWithEmail,
    dataLogWithEmail,
    handleSubmitForm,
    handleOnChangeAsanID,
    handleOpenRecoveryPage,
    handleOnChangeAsanPhone,
    handleChangeFirstInput,
    handleChangeSecondInput,
    handleClickShowPassword,
    handleMouseDownPassword,
  } = useLoginForm(tabNumber);

  return (
    <form style={{ position: 'relative', height: '100%' }} onSubmit={handleSubmitForm}>
      <Typography sx={inputInfo}>{tabNumber === 1 ? t('login.mobileNumber') : 'Email'}</Typography>
      <OutlinedInput
        type={tabNumber === 1 ? 'text' : 'email'}
        placeholder={tabNumber === 1 ? '(00) 000 00 00' : t('login.email')}
        sx={{
          width: '100%',
          mb: '24px',
          pl: '16px',

          '&.Mui-focused': {
            '& .MuiOutlinedInput-notchedOutline': {
              border: `1px solid ${blue}`,
            },

            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: grey,
            },
          },

          '@media screen and (max-height: 864px)': {
            mb: '20px',
          },
        }}
        startAdornment={
          tabNumber === 1 && (
            <InputAdornment position="start">
              <Typography sx={{ fontFamily: 'Yelo', fontWeight: 500 }}>+994</Typography>
            </InputAdornment>
          )
        }
        inputProps={{
          style: { paddingLeft: '0' },
          ...register(tabNumber === 1 ? 'asan_imza_phone' : 'email'),
          maxLength: tabNumber === 1 ? 14 : null,
        }}
        onChange={tabNumber === 1 ? handleOnChangeAsanPhone : handleChangeFirstInput}
        value={firstInput}
      />
      <Typography sx={inputInfo}>{tabNumber === 1 ? t('login.userID') : t('login.password')}</Typography>
      <OutlinedInput
        type={tabNumber === 1 ? 'text' : showPassword ? 'text' : 'password'}
        placeholder={tabNumber === 1 ? t('login.enterUserID') : t('login.enterPass')}
        sx={{
          width: '100%',
          '&.Mui-focused': {
            '& .MuiOutlinedInput-notchedOutline': {
              border: `1px solid ${blue}`,
            },

            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: grey,
            },
          },
        }}
        endAdornment={
          tabNumber !== 1 && (
            <InputAdornment position="end">
              <IconButton onClick={handleClickShowPassword} onMouseDown={handleMouseDownPassword} edge="end">
                {showPassword ? (
                  <VisibilityOffOutlinedIcon style={{ color: grey }} />
                ) : (
                  <VisibilityOutlinedIcon style={{ color: grey }} />
                )}
              </IconButton>
            </InputAdornment>
          )
        }
        inputProps={{
          ...register(tabNumber === 1 ? 'asan_imza_id' : 'password'),
          maxLength: tabNumber === 1 ? 6 : null,
        }}
        onChange={tabNumber === 1 ? handleOnChangeAsanID : handleChangeSecondInput}
        value={secondInput}
      />
      {tabNumber !== 1 && (
        <Box sx={forgetPassBox}>
          <Typography sx={forgetPassText} onClick={handleOpenRecoveryPage}>
            {t('login.forgetPass')}
          </Typography>
        </Box>
      )}
      {(errors.password?.message || dataLogWithEmail?.error) && (
        <Box sx={warningBox}>
          <WarningIcon sx={{ mr: '16px' }} />
          <Typography sx={errorText}>{dataLogWithEmail?.error && dataLogWithEmail?.error.text}</Typography>
        </Box>
      )}

      <Button
        type={'submit'}
        disabled={!(firstInput.length > 0 && secondInput.length > 0) || isLoadingLogWithEmail}
        sx={btn}
        variant={'contained'}
      >
        {isLoadingLogWithEmail ? (
          <CircularProgress sx={{ width: '24px !important', height: '24px !important' }} />
        ) : (
          t('login.continue')
        )}
      </Button>
    </form>
  );
};

export default LoginForm;
